import React, { Fragment } from "react";
// From index.
import { LiElements, LiSingleTreeElement ,LiElementsProject } from "../index";

const user = JSON.parse(localStorage.getItem("user"))
  ? JSON.parse(localStorage.getItem("user"))
  : 0;

const sideBarDatas = {
  dashboard: {
    menuName: "Dashboard",
    menuIcon: "fas fa-home",
    route: "/employeeDashboard",
  },
  dailyWorkStatus: {
    menuName: "Daily Work Status",
    menuIcon: "fab fa-product-hunt",
    route: "/taskManagment",
  },
  // myleave :{
  //   menuName: "My Leaves And Duty",
  //   menuIcon: "fab fa-product-hunt",
  //   route: "/myleave",
  // },
  // dutyapplicationlist :{
  //   menuName: "My Duty",
  //   menuIcon: "fab fa-product-hunt",
  //   route: "/DutyApplicationList",
  // },

  // leaveApplication :{
  //   menuName: "Leave Applications",
  //   menuIcon: "fab fa-product-hunt",
  //   route: "/leaveapplicationlist",
  // },
  //  "Leave Management" :{
  //   menuName: "Leave Management",
  //     menuIcon: "fab fa-product-hunt",
  //     subMenu:[
  //       {
  //         icon:"fab fa-product-hunt",
  //         subMenuName:"My Leaves",
  //         route: "/myleave",
  //       },
  //       {
  //         icon:"fas fab fa-product-hunt",
  //         subMenuName:"Applied Leave",
  //         route: "/myappliedleavelist",
  //       }

  //     ]
  //  },
  "project board": {
    menuName: "Project Board",
    menuIcon: "fab fa-product-hunt",
    subMenu: [
      // {
      //   icon: "fas fab fa-product-hunt",
      //   subMenuName: "Back Logs",
      //   route: "/taskManagment",
      // },
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "Task Board",
        route: "/taskBoard/54",
      },
    ],
  },
"leaves and duty": {
    menuName: "Leaves And Duty",
    menuIcon: "fab fa-product-hunt",
    subMenu: [
      // {
      //   icon: "fas fab fa-product-hunt",
      //   subMenuName: "Back Logs",
      //   route: "/taskManagment",
      // },
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "Apply Leave",
        route: "/ApplyMyLeaves",
      },
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "Leave Balances",
        route: "/MyLeaveList",
      },
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "My Applied Leaves",
        route: "/MyLeaveAppliedList",
      },
       {
        icon: "fas fab fa-product-hunt",
        subMenuName: "My Applied Duties",
        route: "/MyDutyAppliedList",
      },
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "Leave Approval",
        route: "/MyProcessLeaveList",
      },
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "Holiday List",
        route: "/HolidayCalendarList",
      },
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "Leave Calendar",
        route: "/LeaveCalendar",
      },
    ],
  },
  // myRewards: {
  //   menuName: "My Rewards",
  //   menuIcon: "fab fa-product-hunt",
  //   route: `/empRewards`,

  //   // route: `/empRewards/${user.EmployeeId}`,
  // },
  myProfile: {
    menuName: "My Profile",
    menuIcon: "fab fa-product-hunt",
    // route: `/empProfile`,
    route: `/empProfile`,
  },
  viewdailyWorkStatus: {
    menuName: "Project's Work Status",
    menuIcon: "fab fa-product-hunt",
    // route: "/viewtaskManagment",
    route: "/ModernViewTaskManagement",
  },
  viewWorkSummary: {
    menuName: "My Work Summary",
    menuIcon: "fab fa-product-hunt",
    route: "/viewworkSummary",
  },
  Appraisal: {
    menuName: "Appraisal",
    menuIcon: "fas fa-poll",
    // route: `/empProfile`,
    route: `/empAppraisal`,
  },
  reports: {
    menuName: "Reports",
    menuIcon: "fab fa-product-hunt",
    route: "/ReportSummary",
  },
  helpdesk: {
    menuName: "Helpdesk",
    menuIcon: "fab fa-product-hunt",
    subMenu: [
      {
        icon: "fas fab fa-product-hunt",
        subMenuName: "Time Sheet Unlock",
        route: "/taskSheetUnlockStatus",
      },
    ],
  },
};

const EmployeeSideBar = ({
  loginUser,
  handleLeave,
  handleProject,
  handleHelpDesk,
  activeSideBar,
  toggle,
}) => {
  return (
    <Fragment>
      <ul className="list-unstyled components">
        <LiSingleTreeElement
          route={sideBarDatas.dashboard.route}
          menuIcon={sideBarDatas.dashboard.menuIcon}
          menuName={sideBarDatas.dashboard.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement>
        <LiSingleTreeElement
          route={sideBarDatas.dailyWorkStatus.route}
          menuIcon={sideBarDatas.dailyWorkStatus.menuIcon}
          menuName={sideBarDatas.dailyWorkStatus.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement>
        {JSON.parse(localStorage.getItem("user")).ProjectId === '0' ? null : (<LiSingleTreeElement
          route={sideBarDatas.viewdailyWorkStatus.route}
          menuIcon={sideBarDatas.viewdailyWorkStatus.menuIcon}
          menuName={sideBarDatas.viewdailyWorkStatus.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement>)}
        <LiSingleTreeElement
          route={sideBarDatas.viewWorkSummary.route}
          menuIcon={sideBarDatas.viewWorkSummary.menuIcon}
          menuName={sideBarDatas.viewWorkSummary.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement>
        {JSON.parse(localStorage.getItem("user")).ProjectId === '0' ? null : (<LiElementsProject
          liData={sideBarDatas["project board"]}
          toggleList={handleProject.func}
          isOpenList={handleProject.state}
          activeSideBar={activeSideBar}
          toggle={toggle}
          projectId={JSON.parse(localStorage.getItem("user")).ProjectId}
        ></LiElementsProject>)}
<LiElementsProject
          liData={sideBarDatas["leaves and duty"]}
          toggleList={handleLeave.func}
          isOpenList={handleLeave.state}
          activeSideBar={activeSideBar}
          toggle={toggle}
         
        ></LiElementsProject>
        {/* My Reward */}
        {/* <LiSingleTreeElement
          route={`${sideBarDatas.myRewards.route}/${loginUser.EmployeeId}`}
          menuIcon={sideBarDatas.myRewards.menuIcon}
          menuName={sideBarDatas.myRewards.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement> */}
        {/* My profile */}
        {JSON.parse(localStorage.getItem("user")).EmployeeId == undefined ? null : (<LiSingleTreeElement
          route={`${sideBarDatas.myProfile.route}/${loginUser.EmployeeId}`}
          menuIcon={sideBarDatas.myProfile.menuIcon}
          menuName={sideBarDatas.myProfile.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement>)}
        {/* <LiSingleTreeElement
          route={`${sideBarDatas.myleave.route}`}
          menuIcon={sideBarDatas.myleave.menuIcon}
          menuName={sideBarDatas.myleave.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement> */}
        {/* <LiSingleTreeElement
          route={`${sideBarDatas.dutyapplicationlist.route}`}
          menuIcon={sideBarDatas.dutyapplicationlist.menuIcon}
          menuName={sideBarDatas.dutyapplicationlist.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement> */}
        {/* Project Board */}
        {/* <LiElements
          liData={sideBarDatas["Leave Management"]}
          toggleList={handleLeave.func}
          isOpenList={handleLeave.state}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiElements> */}

        <LiSingleTreeElement
          route={`${sideBarDatas.Appraisal.route}`}
          menuIcon={sideBarDatas.Appraisal.menuIcon}
          menuName={sideBarDatas.Appraisal.menuName}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement>

        <LiSingleTreeElement
          menuName={sideBarDatas.reports.menuName}
          menuIcon={sideBarDatas.reports.menuIcon}
          route={sideBarDatas.reports.route}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiSingleTreeElement>
        <LiElements
          liData={sideBarDatas.helpdesk}
          toggleList={handleHelpDesk.func}
          isOpenList={handleHelpDesk.state}
          activeSideBar={activeSideBar}
          toggle={toggle}
        ></LiElements>
      </ul>
    </Fragment>
  );
};

export default EmployeeSideBar;
